import type { ParsedUrlQuery } from 'querystring';
import { omit } from '@sortlist-frontend/utils';

const INTERNAL_QUERY_PARAMS = ['custom', 'disableCache'];

const toEntries = (query: ParsedUrlQuery) =>
  Object.entries(query).flatMap(([key, value]) => [value ?? []].flat().map((item) => [key, item]));

export const omitInternalQueryParams = (query: ParsedUrlQuery): ParsedUrlQuery => omit(query, INTERNAL_QUERY_PARAMS);

export const toPublicQueryString = (query: ParsedUrlQuery | URLSearchParams) => {
  const searchParams = new URLSearchParams(query instanceof URLSearchParams ? query : toEntries(query));
  INTERNAL_QUERY_PARAMS.forEach((param) => searchParams.delete(param));
  return searchParams.toString();
};
